import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const dark = tone === 'dark';
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-2" data-mp="3c3yz6sltcq9n">
      <p className={`mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wider ${dark ? 'text-gold' : 'text-danger'}`} data-id="element-3" data-mp="3h2k1cxkmlk0q">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-4" data-mp="3262mvxh53p9y" />
        This special offer ends in:
      </p>
      <div className="flex items-start gap-2 sm:gap-3" data-id="element-5" data-mp="10cbsrg76aze9">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-6" data-mp="10aino5c7kn8d" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-7" data-mp="15bocvt6ntsd5">
              <span className={`flex h-[72px] w-[76px] items-center justify-center rounded-xl font-serif text-[40px] font-black tabular-nums sm:h-20 sm:w-20 ${dark ? 'bg-gold text-ink' : 'bg-ink text-gold'}`} data-id="element-8" data-mp="15925punolevg">
                {u.value}
              </span>
              <span className={`mt-1.5 text-xs font-semibold uppercase tracking-wider ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-9" data-mp="12rd8d6kuhk7d">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`mt-4 font-serif text-3xl font-black ${dark ? 'text-gold' : 'text-ink'}`} data-id="element-10" data-mp="a4iy12hqs17m">:</span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-3 text-sm ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-11" data-mp="k15k1ult0yb8">Limited-time launch pricing.</p>
    </div>;
}